import React from 'react';
import Link from 'next/link';
import SelectBox from '../../common/components/SelectBox';
import values from '../config/values';
import { routes } from '../../../constants/routes';

const Menu = ({ subject, category, onSelectCategory, selected }) => {
  const renderSelectCategory = () => {
    if (subject === 'total') {
      return null;
    }

    return (
      <div className="select-box-container">
        <SelectBox
          labels={category}
          defaultSelected={selected.name}
          onSelected={onSelectCategory}
        />
      </div>
    );
  };

  return (
    <div className="menu">
      <ul className="tab-type2 cell-6">
        {values.menu.map((menu) => (
          <li
            key={menu.subject}
            className={subject === menu.subject ? 'on' : ''}
          >
            <Link
              id={`reference-room-tab-${menu.subject}`}
              href={`${routes.referenceRoom}?subject=${menu.subject}`}
            >
              {menu.content}
            </Link>
          </li>
        ))}
      </ul>
      {renderSelectCategory()}
    </div>
  );
};

export default Menu;
